(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.view :as esg]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.view
    :refer [portfolio-locations-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.stacked-text-group.view
    :refer
    [stacked-text-group]]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]))


(defn hotel-section
  [holding-ui-data props]
  (let [{:keys [holding-name overview map-data
                portfolio-summary-text recent-development-text
                basic-information key-financials-and-kpis]}
        holding-ui-data]
    [section
     holding-name
     nil
     [:div
      [grid/row {}
       [grid/column {:span 12}
        [card
         {:title ""}
         [:<>
          [free-text-card/free-text-section "Portfolio Summary" portfolio-summary-text props]
          [free-text-card/free-text-section "Recent Developments" recent-development-text props]]
         [:div
          [tabular-card/dynamic-stacked-table overview props]
          [portfolio-locations-card map-data props]]]]]

      [grid/row {}
       [tabular-card/dynamic-table "Basic Information" basic-information props]]
      [grid/row {}
       [tabular-card/dynamic-table "Key Financials & KPIs" key-financials-and-kpis props]]]]))

(defn hotel
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name overview map-data
                portfolio-summary-text recent-development-text
                basic-information key-financials-and-kpis]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [hotel-section holding-ui-data props]]))

(defn property-esg
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [hotel-section holding-ui-data props]
     [esg/esg-section holding-ui-data props]]))


(defn portfolio-esg
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [hotel-section holding-ui-data props]
     [esg/portfolio-esg-section holding-ui-data props]]))
